import { useEffect } from "react";

/** @deprecated */
export default function useStartup(startupCallback: React.EffectCallback, shutdownCallback?: () => void) {
    useEffect(() => {
        startupCallback();
        return shutdownCallback;
        // eslint-disable-next-line react-hooks/exhaustive-deps -- non-exhaustive deps is key to this hook; rather than trying to fix this hook, we should phase out it's use (marked as @deprecated)
    }, []);
}

/** @deprecated */
export function useShutdown(shutdownCallback: () => void) {
    useEffect(() => {
        return shutdownCallback;
        // eslint-disable-next-line react-hooks/exhaustive-deps -- non-exhaustive deps is key to this hook; rather than trying to fix this hook, we should phase out it's use (marked as @deprecated)
    }, []);
}